import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconReview = ({ id, color, width = 50, style, ...restProps }: IProps) => {
  const viewBoxWidth = 50;
  const viewBoxHeight = 48;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M25 36.569c.31 0 .62.074.902.224l10.778 5.696-2.059-12.066a1.956 1.956 0 0 1 .558-1.724l8.72-8.545-12.051-1.76a1.941 1.941 0 0 1-1.46-1.066L25 6.35l-5.389 10.978a1.941 1.941 0 0 1-1.459 1.066l-12.05 1.76L14.82 28.7c.456.447.666 1.092.558 1.724l-2.06 12.066 10.78-5.696c.282-.15.59-.224.901-.224M39.253 48c-.31 0-.619-.074-.902-.224L25 40.718l-13.352 7.057a1.921 1.921 0 0 1-2.04-.148 1.953 1.953 0 0 1-.772-1.905l2.55-14.948L.586 20.19a1.956 1.956 0 0 1-.491-1.998 1.94 1.94 0 0 1 1.563-1.325l14.928-2.18 6.676-13.6a1.934 1.934 0 0 1 3.476-.001l6.676 13.6 14.928 2.18a1.94 1.94 0 0 1 1.563 1.325c.228.706.038 1.48-.49 1.998L38.614 30.774l2.55 14.948c.124.73-.175 1.47-.772 1.905a1.922 1.922 0 0 1-1.138.372"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconReview;
